import BaseModel from '../core/BaseModel'
export default class GroupUserModel extends BaseModel {

    constructor() {
        super({ 
                name: "group_user",
                tableName: 'group_user',
                label: "Phân công",
                display_key: 'name',
                default_order: { key: 'ordinal', direction: 'asc' } ,
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Bigint",
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            user_name: {
                name: 'user_name',
                type: "String",
                label: 'Tên người dùng',
                sortable: false,
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.user_name = "";
                }
            },
            created_by: {
                name: 'created_by',
                type: "String",
                label: 'Người tạo',
                sortable: false,
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.created_by = "";
                }
            },
            created_at: {
                name: 'created_at',
                type: "Datetime",
                label: 'Ngày tạo',
                filter: {
                    type: "DateRange", match: "contrains",
                },
            },
            group: {
                refs: 'group {id name}',
                display: false
            },
            user: {
                refs: 'user {id fullname}',
                display: false
            },
            created_by_user: {
                refs: 'created_by_user {id fullname}',
                display: false
            },
        },)
    }

}
